import { render, staticRenderFns } from "./View9.vue?vue&type=template&id=8b5ee5a8&scoped=true&"
import script from "./View9.vue?vue&type=script&lang=js&"
export * from "./View9.vue?vue&type=script&lang=js&"
import style0 from "./View9.vue?vue&type=style&index=0&id=8b5ee5a8&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b5ee5a8",
  null
  
)

export default component.exports